import { render, staticRenderFns } from "./TextImage3.vue?vue&type=template&id=1ed85683&scoped=true"
import script from "./TextImage3.vue?vue&type=script&lang=js"
export * from "./TextImage3.vue?vue&type=script&lang=js"
import style0 from "./TextImage3.vue?vue&type=style&index=0&id=1ed85683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed85683",
  null
  
)

export default component.exports